export default __webpack_public_path__ + "static/media/cover.5c77e77f.jpg";